/**
 * Script simples para fazer todos os reviews parecerem verificados
 * Funciona apenas com Judge.me
 */

class VerifiedReviewsManager {
  constructor() {
    this.observer = null;
    this.processedReviews = new Set();
    this.init();
  }

  init() {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this.start());
    } else {
      this.start();
    }
  }

  start() {
    this.processAllReviews();
    this.startObserver();
    this.startPaginationWatch();
  }

  startObserver() {
    this.observer = new MutationObserver((mutations) => {
      let shouldProcess = false;

      mutations.forEach((mutation) => {
        if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
                      mutation.addedNodes.forEach((node) => {
              if (node.nodeType === Node.ELEMENT_NODE && 
                  (node instanceof HTMLElement) &&
                  node.classList?.contains('jdgm-rev')) {
                shouldProcess = true;
              }
            });
        }
      });

      if (shouldProcess) {
        setTimeout(() => this.processAllReviews(), 500);
      }
    });

    this.observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  startPaginationWatch() {
    // Verifica periodicamente por novos reviews (para paginação)
    setInterval(() => {
      this.processAllReviews();
    }, 300);

    // Observa cliques nos botões de paginação
    document.addEventListener('click', (event) => {
      const target = event.target;
      if (target && target instanceof Element && 
          (target.closest('.jdgm-paginate') || 
           target.closest('.jdgm-prev-page') || 
           target.closest('.jdgm-next-page') ||
           target.closest('[class*="page"]'))) {

        setTimeout(() => {
          this.processAllReviews();
        }, 1000);
      }
    });

    // Observa mudanças na URL (caso use hash)
    let lastUrl = location.href;
    new MutationObserver(() => {
      const url = location.href;
      if (url !== lastUrl) {
        lastUrl = url;

        setTimeout(() => {
          this.processAllReviews();
        }, 500);
      }
    }).observe(document, { subtree: true, childList: true });
  }

  processAllReviews() {
    // Encontra todos os reviews não verificados
    const unverifiedReviews = document.querySelectorAll('.jdgm-rev[data-verified-buyer="false"]');
    
    unverifiedReviews.forEach(review => {
      const reviewId = review.getAttribute('data-review-id');
      
      if (!this.processedReviews.has(reviewId)) {
        this.makeReviewVerified(review);
        this.processedReviews.add(reviewId);
      }
    });

    // Adiciona as medalhas se não existirem
    this.addMedalsIfMissing();
  }

  makeReviewVerified(review) {
    try {
      // 1. Muda o atributo para true
      review.setAttribute('data-verified-buyer', 'true');
      
      // 2. Encontra o author wrapper
      const authorWrapper = review.querySelector('.jdgm-rev__author-wrapper');
      if (!authorWrapper) {
        return false;
      }
      
      // 3. Verifica se já tem badge
      if (authorWrapper.querySelector('.jdgm-rev__buyer-badge-wrapper')) {
        return false;
      }
      
      // 4. Cria e adiciona o badge
      const badgeWrapper = document.createElement('span');
      badgeWrapper.className = 'jdgm-rev__buyer-badge-wrapper';
      badgeWrapper.innerHTML = '<span class="jdgm-rev__buyer-badge"></span>';
      
      // 5. Adiciona um espaço antes do badge
      authorWrapper.appendChild(document.createTextNode(' '));
      authorWrapper.appendChild(badgeWrapper);
      
      return true;
      
    } catch (error) {
      return false;
    }
  }

  addMedalsIfMissing() {
    // Verifica se já existe a seção de medalhas
    const existingMedals = document.querySelector('.jdgm-medals-wrapper');
    if (existingMedals) {
      return;
    }

    // Procura onde inserir as medalhas (após o header ou antes dos reviews)
    const header = document.querySelector('.jdgm-rev-widg__header');
    const reviewsList = document.querySelector('.jdgm-rev');
    
    let insertTarget = null;
    if (header) {
      insertTarget = header;
    } else if (reviewsList && reviewsList.parentNode) {
      insertTarget = reviewsList.parentNode;
    }

    if (!insertTarget) {
      return;
    }

    // Cria a estrutura das medalhas
    const medalsHTML = `
      <div class="jdgm-row-media">
        <div class="jdgm-medals-wrapper"> 
          <style type="text/css"></style> 
          <div class="jdgm-medals" data-link="https://app.judge.me/reviews/medals"> 
            <div class="jdgm-medals__container"> 
              <div class="jdgm-medal-wrapper" title="Diamond Authentic Shop. 100% of published reviews are verified reviews"> 
                <a class="jdgm-medal" data-value="100.0" data-type="auth" data-tier="diamond"> 
                  <div class="jdgm-medal__image" data-url="auth/diamond.svg" data-alt="Judge.me Diamond Authentic Shop medal">
                    <img alt="Judge.me Diamond Authentic Shop medal" src="https://judgeme-public-images.imgix.net/judgeme/medals-v2-2025-rebranding/auth/diamond.svg?auto=format">
                  </div> 
                  <div class="jdgm-medal__value">100.0</div> 
                </a> 
              </div> 
              <div class="jdgm-medal-wrapper" title="Diamond Transparent Shop. Published 100% of verified reviews received in total"> 
                <a class="jdgm-medal" data-value="100.0" data-type="tran" data-tier="diamond"> 
                  <div class="jdgm-medal__image" data-url="tran/diamond.svg" data-alt="Judge.me Diamond Transparent Shop medal">
                    <img alt="Judge.me Diamond Transparent Shop medal" src="https://judgeme-public-images.imgix.net/judgeme/medals-v2-2025-rebranding/tran/diamond.svg?auto=format">
                  </div> 
                  <div class="jdgm-medal__value">100.0</div> 
                </a> 
              </div> 
            </div> 
          </div> 
        </div>
      </div>
    `;

    // Insere as medalhas após o header
    if (header) {
      header.insertAdjacentHTML('afterend', medalsHTML);
    } else if (insertTarget instanceof HTMLElement) {
      insertTarget.insertAdjacentHTML('beforebegin', medalsHTML);
    }
  }

  destroy() {
    if (this.observer) {
      this.observer.disconnect();
      this.observer = null;
    }
  }
}

// Inicia o script
const verifiedReviewsManager = new VerifiedReviewsManager(); 